<!-- 新建/编辑 本地图文模板 的 富文本  -->
<template>
<a-modal
	  :title="`插入链接`"
	  :visible="visible"
	  :confirm-loading="confirmLoading"
	  cancelText="取消"
	  okText="确认" 
	  width="800px" 
	  @ok="modalOk"
	  @cancel="modalCancel"
	  
	>
	
	<div class="form-cell-box">
		<div class="class-title" >选择链接</div>
			
		<a-select
			show-search
			style="width: 550px;"
			placeholder="请选择链接"
			@change="handleChangeA"
			:filter-option="filterOption"
			:getPopupContainer="getsPopupContainer"
			:value="link_url"
		  >
			<a-select-option v-for="(value,key) in linkSelecr" :key="key" :value="key" :title="key">
			  {{value}}（{{key}}）
			</a-select-option>
		</a-select>
	</div>
	
	<div class="form-cell-box">
		<div class="class-title" >输入文案</div>
			
		<a-input v-model="link_text" placeholder="请输入文案" allowClear style="width: 550px;"/>
	</div>
	
	<div class="form-cell-box" style="align-items: flex-start;">
		<div class="class-title">说明</div>
		<div style="color: #E85A32;">
			<div style="margin-bottom: 5px;">1. 创建草稿时，此处选择的链接，会被替换为公众号的链接。当前只支持乐读书城。</div>
			<div>2. 公众号需要开通微信支付，才能添加外部链接，否则添加的链接会被自动去掉。</div>
		</div>
	</div>
	
	<!-- 微信文章f12-复制过来的html结构 -->
	<!-- <p style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; clear: both; min-height: 1em; font-size: 17px; letter-spacing: 0.544px; background-color: rgb(255, 255, 255); color: rgb(51, 51, 51); font-family: -apple-system, BlinkMacSystemFont, &quot;Helvetica Neue&quot;, &quot;PingFang SC&quot;, &quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;, Arial, sans-serif; text-align: center; box-sizing: border-box !important; overflow-wrap: break-word !important; visibility: visible;">
		<a href="https://5a68e05c9d10005518.api.novelquickapp.com/page/novelsale/history?tab=read_history&amp;aid=10005518" style="visibility: visible;">
			<span style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; box-sizing: border-box !important; word-wrap: break-word !important; color: #ffffff; font-size: 32px; letter-spacing: 0.544px; background-color: #ff2941; visibility: visible; overflow-wrap: break-word !important;" data-darkmode-bgcolor-16158778700373="rgb(255, 41, 65)" data-darkmode-original-bgcolor-16158778700373="#fff|rgb(255, 41, 65)" data-darkmode-color-16158778700373="rgb(255, 255, 255)" data-darkmode-original-color-16158778700373="#fff|rgb(255, 255, 255)">
				<strong style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; line-height: 25.6px; box-sizing: border-box !important; overflow-wrap: break-word !important; visibility: visible;">
					<span style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; font-size: 12px; color: rgb(136, 136, 136); box-sizing: border-box !important; overflow-wrap: break-word !important; visibility: visible;">
						<span style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; box-sizing: border-box !important; word-wrap: break-word !important; color: #ffffff; font-size: 32px; letter-spacing: 0.544px; visibility: visible; overflow-wrap: break-word !important;" data-darkmode-bgcolor-16158778700373="rgb(255, 41, 65)" data-darkmode-original-bgcolor-16158778700373="#fff|rgb(255, 41, 65)" data-darkmode-color-16158778700373="rgb(255, 255, 255)" data-darkmode-original-color-16158778700373="#fff|rgb(255, 255, 255)">
							👉点此阅读全集故事
						</span>
					</span>
				</strong>
			</span>
		</a>
	</p> -->
	<!-- <p style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; clear: both; min-height: 1em; font-size: 17px; letter-spacing: 0.544px; background-color: rgb(255, 255, 255); color: rgb(51, 51, 51); font-family: -apple-system, BlinkMacSystemFont, &quot;Helvetica Neue&quot;, &quot;PingFang SC&quot;, &quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;, Arial, sans-serif; text-align: center; box-sizing: border-box !important; overflow-wrap: break-word !important; visibility: visible;">
		<a href="https://5a68e05c9d10005518.api.novelquickapp.com/page/novelsale/history?tab=read_history&amp;aid=10005518" style="visibility: visible;">
			<strong style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; line-height: 25.6px; white-space: pre-wrap; box-sizing: border-box !important; overflow-wrap: break-word !important; visibility: visible;">
				<span style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; font-size: 12px; color: rgb(136, 136, 136); box-sizing: border-box !important; overflow-wrap: break-word !important; visibility: visible;">
					<span style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; box-sizing: border-box !important; word-wrap: break-word !important; color: #ffffff; font-size: 32px; letter-spacing: 0.544px; background-color: #ff2941; visibility: visible; overflow-wrap: break-word !important;" data-darkmode-bgcolor-16158778700373="rgb(255, 41, 65)" data-darkmode-original-bgcolor-16158778700373="#fff|rgb(255, 41, 65)" data-darkmode-color-16158778700373="rgb(255, 255, 255)" data-darkmode-original-color-16158778700373="#fff|rgb(255, 255, 255)">
						<strong style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; line-height: 25.6px; box-sizing: border-box !important; overflow-wrap: break-word !important; visibility: visible;">
							<span style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; font-size: 12px; color: rgb(136, 136, 136); box-sizing: border-box !important; overflow-wrap: break-word !important; visibility: visible;">
								<span style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; box-sizing: border-box !important; word-wrap: break-word !important; color: #ffffff; font-size: 32px; letter-spacing: 0.544px; visibility: visible; overflow-wrap: break-word !important;" data-darkmode-bgcolor-16158778700373="rgb(255, 41, 65)" data-darkmode-original-bgcolor-16158778700373="#fff|rgb(255, 41, 65)" data-darkmode-color-16158778700373="rgb(255, 255, 255)" data-darkmode-original-color-16158778700373="#fff|rgb(255, 255, 255)">
									👉点此阅读全集故事
								</span>
							</span>
						</strong>
					</span>
				</span>
			</strong>
		</a>
	</p> -->
	<!-- <span style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; box-sizing: border-box !important; word-wrap: break-word !important; color: #ffffff; font-size: 32px; letter-spacing: 0.544px; background-color: #ff2941; visibility: visible; overflow-wrap: break-word !important;" data-darkmode-bgcolor-16158778700373="rgb(255, 41, 65)" data-darkmode-original-bgcolor-16158778700373="#fff|rgb(255, 41, 65)" data-darkmode-color-16158778700373="rgb(255, 255, 255)" data-darkmode-original-color-16158778700373="#fff|rgb(255, 255, 255)">
		<strong style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; line-height: 25.6px; box-sizing: border-box !important; overflow-wrap: break-word !important; visibility: visible;">
			<span style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; font-size: 12px; color: rgb(136, 136, 136); box-sizing: border-box !important; overflow-wrap: break-word !important; visibility: visible;">
				<span style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; box-sizing: border-box !important; word-wrap: break-word !important; color: #ffffff; font-size: 32px; letter-spacing: 0.544px; visibility: visible; overflow-wrap: break-word !important;" data-darkmode-bgcolor-16158778700373="rgb(255, 41, 65)" data-darkmode-original-bgcolor-16158778700373="#fff|rgb(255, 41, 65)" data-darkmode-color-16158778700373="rgb(255, 255, 255)" data-darkmode-original-color-16158778700373="#fff|rgb(255, 255, 255)">
					👉点此阅读全集故事
				</span>
			</span>
		</strong>
	</span> -->
</a-modal>
</template>

<script>
import { getBookOftenLink } from '@/request/api'
export default {
	name: 'InsertLink_',
	props: [],
	data(){
		return {
			visible: false,
			confirmLoading: false,
			
			linkSelecr: {},
			link_url: undefined,
			link_text: null, // 插入的链接文案
		}
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		showModal(){
			let that = this
			that.link_url = undefined // 这是为了把之前选择过的内容清空
			that.link_text = null  // 这是为了把之前选择过的内容清空
			getBookOftenLink().then(res=>{
				console.log("乐读书城常用地址下拉",res);
				that.linkSelecr = res.data['h5']
				that.visible = true
				
			})
		},
		handleChangeA(e){
			console.log(e);
			this.link_url = e
		},
		modalOk(){
			if(!this.link_url){
				this.$message.warning('请选择内容');
				return
			}
			else if(!this.link_text){
				this.$message.warning('请输入文案');
				return
			}
			this.modalCancel()
			this.$emit("insert-link", this.link_url, this.link_text)
		},
		modalCancel(){
			this.visible = false
		},
	}
}
</script>

<style>
</style>